import { useEffect, useState } from "react";
import { CartItem, CartItemLogo } from "../models/CartItem";
import { useLogoRepository } from "../../../../data/repositories/LogoRepository";

interface ProductPreviewLogoProps {
  orderline: CartItem;
}

export function ProductPreviewLogo({ orderline }: ProductPreviewLogoProps) {
  const repo = useLogoRepository();
  const [src, setSrc] = useState(
    orderline.displayImage.highResUrl || orderline.displayImage.lowResUrl
  );

  const alt = orderline.title;

  const logoItem = orderline as CartItemLogo;
  const logoQuery = repo.useLogo(logoItem.baseLogo.customerId, logoItem.logoId);

  useEffect(() => {
    setSrc(
      orderline.displayImage.highResUrl || orderline.displayImage.lowResUrl
    );
  }, [orderline.displayImage.highResUrl, orderline.displayImage.lowResUrl]);

  useEffect(() => {
    const high = (logoQuery as any)?.data?.displayImage?.highResUrl;
    if (high) {
      setSrc(high);
    }
  }, [logoQuery?.data]);

  return (
    <div
      className={"flex space-x-2 justify-center items-center w-full"}
      style={{ minHeight: "400px", backgroundColor: "#F8FAFD" }}
    >
      <img src={src} alt={alt} className="w-full h-full object-contain p-28" />
    </div>
  );
}
